import React from 'react'

import { ThemeProvider } from '@walltowall/system'

import { theme } from './theme'

export const wrapPageElement = ({ element, props }, { pathPrefix }) => {
  const location = props.location

  if (
    !location.pathname.startsWith(`/${pathPrefix}/`) ||
    location.pathname.startsWith(`/${pathPrefix}/examples/`)
  )
    return element

  return <ThemeProvider theme={theme}>{element}</ThemeProvider>
}
